import {LockAccountUseCase} from "@core/entities/account/application/use-cases/lock-account.use-case";
import {DestroyRef, inject, Injectable} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {filter, map, merge, switchMap} from 'rxjs';
import {EventBusPort} from "@platform/event-bus/domain/ports/event-bus.port";
import {
  PaymentStatus,
  PaymentStatusChangedEvent
} from "@platform/event-bus/domain/events/payment/payment-status-changed.event";

@Injectable()
export class AccountPaymentSubscriber {
  private readonly destroyRef = inject(DestroyRef);
  private readonly eventBus = inject(EventBusPort);
  private readonly lockAccount = inject(LockAccountUseCase);

  constructor() {
    merge(
      this.eventBus.ofType(PaymentStatusChangedEvent).pipe(
        filter(({payload}) => payload.status === PaymentStatus.CHECKOUT),
        map(() => true),
      ),
      this.eventBus.ofType(PaymentStatusChangedEvent).pipe(
        filter(({payload}) => payload.status === PaymentStatus.SUCCESS),
        map(() => false),
      ),
      this.eventBus.ofType(PaymentStatusChangedEvent).pipe(
        filter(({payload}) => payload.status === PaymentStatus.ERROR || payload.status === PaymentStatus.FAILED),
        map(() => false),
      ),
    )
      .pipe(
        switchMap(isLocked => this.lockAccount.execute(isLocked)),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe();
  }

}
